import api from './api';

export default {
  async search(params) {
    return await api.get(`aggregators/${params.aggregator_id}/simulation_result_forecast`, { params });
  },
  async downloadForecast(params, resource_type) {
    return await api.get(`/files/csv/forecast_simulations/${params.simulation_id}/resource_types/${resource_type}/electric_power/forecast_and_actual`, { responseType:'blob', dataType:'binary' });
  }
}